import { OrdersTable } from "@/components/orders/OrdersTable";
import { PageHeader } from "@/components/shared/page-header";

export function OrdersPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Orders" />
      <OrdersTable />
    </div>
  );
}
